import objectPath from 'object-path'
import { isFilled } from './condition/State'

export const saveStorage = (jsonForm, uischema, name, value) => {
  let { formCode } = jsonForm
  let storage = getStorage(jsonForm) || {}
  objectPath.set(storage, name, value)
  let storageJson = JSON.stringify(storage)
  if (uischema.sessionStorage) {
    sessionStorage.setItem(formCode, storageJson)
  }
  if (uischema.localStorage) {
    localStorage.setItem(formCode, storageJson)
  }
}

export const getStorage = (jsonForm, name = '') => {
  let { formCode } = jsonForm
  let sessionValue = sessionStorage.getItem(formCode)
  let sessionJson = JSON.parse(sessionValue)
  let localStorageValue = localStorage.getItem(formCode)
  let localStorageJson = JSON.parse(localStorageValue)
  if (isFilled(objectPath.get(sessionJson, name)))
    return objectPath.get(sessionJson, name)
  if (isFilled(objectPath.get(localStorageJson, name)))
    return objectPath.get(localStorageJson, name)
  return
}
